"use client";
import { anatomy } from "@zag-js/combobox";
//#region src/components/combobox/combobox.anatomy.ts
var comboboxAnatomy = anatomy.extendWith("empty");
//#endregion
export { comboboxAnatomy };
